import { Route, Switch } from 'react-router-dom';
import AppRouter from 'common/AppRouter';
import { Padding, WhiteSection } from 'components/base/layout-components';
import Permissions from './permissions/Permissions';
import Users from '../../views/Users';
import InviteUser from './InviteUser/InviteUser';

const UsersRouter = () => (
  <WhiteSection>
    <Padding t='x-medium'>
      <Switch>
        <Route
          exact
          path={AppRouter.USERS_PERMISSIONS.path}
          component={Permissions}
        />
        <Route
          exact
          path={AppRouter.USERS_PERMISSIONS_MULTIPLE.path}
          render={() => <Permissions isMultiple />}
        />
        <Route
          exact
          path={AppRouter.USERS_INVITE_USER.path}
          component={InviteUser}
        />
        <Route path='*' component={Users} />
      </Switch>
    </Padding>
  </WhiteSection>
);

export default UsersRouter;
